export const POST_SIGN_UP_REQUEST = 'POST_SIGN_UP_REQUEST'
export const POST_SIGN_UP_SUCCESS = 'POST_SIGN_UP_SUCCESS'
export const POST_SIGN_UP_FAILURE = 'POST_SIGN_UP_FAILURE'

export const postSignUpRequest = (requestBody) => ({ type: POST_SIGN_UP_REQUEST, payload: requestBody })
export const postSignUpSuccess = (data) => ({ type: POST_SIGN_UP_SUCCESS, data })
export const postSignUpFailure = (error) => ({ type: POST_SIGN_UP_FAILURE, payload: error })

export const GET_VERIFY_SIGN_UP_INVITATION_REQUEST = 'GET_VERIFY_SIGN_UP_INVITATION_REQUEST'
export const GET_VERIFY_SIGN_UP_INVITATION_SUCCESS = 'GET_VERIFY_SIGN_UP_INVITATION_SUCCESS'
export const GET_VERIFY_SIGN_UP_INVITATION_FAILURE = 'GET_VERIFY_SIGN_UP_INVITATION_FAILURE'

export const getVerifyInvitationRequest = (invitationToken) => ({ type: GET_VERIFY_SIGN_UP_INVITATION_REQUEST, payload: invitationToken })
export const getVerifyInvitationSuccess = (data) => ({ type: GET_VERIFY_SIGN_UP_INVITATION_SUCCESS, data })
export const getVerifyInvitationFailure = (error) => ({ type: GET_VERIFY_SIGN_UP_INVITATION_FAILURE, payload: error })

export const POST_FORGOT_PASSWORD_REQUEST = 'POST_FORGOT_PASSWORD_REQUEST'
export const POST_FORGOT_PASSWORD_SUCCESS = 'POST_FORGOT_PASSWORD_SUCCESS'
export const POST_FORGOT_PASSWORD_FAILURE = 'POST_FORGOT_PASSWORD_FAILURE'

export const postForgotPasswordRequest = (targetEmail) => ({ type: POST_FORGOT_PASSWORD_REQUEST, payload: targetEmail })
export const postForgotPasswordSuccess = (data) => ({ type: POST_FORGOT_PASSWORD_SUCCESS, data })
export const postForgotPasswordFailure = (error) => ({ type: POST_FORGOT_PASSWORD_FAILURE, payload: error })


export const POST_SLACK_PROCEDURES_REQUEST = 'POST_SLACK_PROCEDURES_REQUEST'
export const POST_SLACK_PROCEDURES_SUCCESS = 'POST_SLACK_PROCEDURES_SUCCESS'
export const POST_SLACK_PROCEDURES_FAILURE = 'POST_SLACK_PROCEDURES_FAILURE'

export const postSlackProceduresRequest = (payload) => ({ type: POST_SLACK_PROCEDURES_REQUEST, payload })
export const postSlackProceduresSuccess = (data) => ({ type: POST_SLACK_PROCEDURES_SUCCESS, data })
export const postSlackProceduresFailure = (error) => ({ type: POST_SLACK_PROCEDURES_FAILURE, payload: error })

export const POST_RESET_PASSWORD_REQUEST = 'POST_RESET_PASSWORD_REQUEST'
export const POST_RESET_PASSWORD_SUCCESS = 'POST_RESET_PASSWORD_SUCCESS'
export const POST_RESET_PASSWORD_FAILURE = 'POST_RESET_PASSWORD_FAILURE'

export const postResetPasswordRequest = (requestBody) => ({ type: POST_RESET_PASSWORD_REQUEST, payload: { requestBody } })
export const postResetPasswordSuccess = (data) => ({ type: POST_RESET_PASSWORD_SUCCESS, data })
export const postResetPasswordFailure = (error) => ({ type: POST_RESET_PASSWORD_FAILURE, payload: error })

export const GET_VERIFY_RESET_PASSWORD_REQUEST = 'GET_VERIFY_RESET_PASSWORD_REQUEST'
export const GET_VERIFY_RESET_PASSWORD_SUCCESS = 'GET_VERIFY_RESET_PASSWORD_SUCCESS'
export const GET_VERIFY_RESET_PASSWORD_FAILURE = 'GET_VERIFY_RESET_PASSWORD_FAILURE'

export const getVerifyResetPasswordRequest = (resetPasswordToken) => ({ type: GET_VERIFY_RESET_PASSWORD_REQUEST, payload: resetPasswordToken })
export const getVerifyResetPasswordSuccess = (data) => ({ type: GET_VERIFY_RESET_PASSWORD_SUCCESS, data })
export const getVerifyResetPasswordFailure = (error) => ({ type: GET_VERIFY_RESET_PASSWORD_FAILURE, payload: error })

export const POST_LOG_IN_REQUEST = 'POST_LOGIN_REQUEST'
export const POST_LOG_IN_SUCCESS = 'POST_LOGIN_SUCCESS'
export const POST_LOG_IN_FAILURE = 'POST_LOGIN_FAILURE'

export const postLoginRequest = (credentials) => ({ type: POST_LOG_IN_REQUEST, payload: credentials })
export const postLoginSuccess = (data) => ({ type: POST_LOG_IN_SUCCESS, data })
export const postLoginFailure = (error) => ({ type: POST_LOG_IN_FAILURE, payload: error })

export const POST_REFRESH_TOKEN_REQUEST = 'POST_REFRESH_TOKEN_REQUEST'
export const POST_REFRESH_TOKEN_SUCCESS = 'POST_REFRESH_TOKEN_SUCCESS'
export const POST_REFRESH_TOKEN_FAILURE = 'POST_REFRESH_TOKEN_FAILURE'

export const postRefreshTokenRequest = () => ({ type: POST_REFRESH_TOKEN_REQUEST })
export const postRefreshTokenSuccess = (data) => ({ type: POST_REFRESH_TOKEN_SUCCESS, data })
export const postRefreshTokenFailure = (error) => ({ type: POST_REFRESH_TOKEN_FAILURE, payload: error })

export const USER_PAYMENT_EXPIRE = 'USER_PAYMENT_EXPIRE'

export const userPaymentExpire = (requestBody) => ({ type: USER_PAYMENT_EXPIRE, data: requestBody })
